import {InaccessibleInfo} from 'auth/RequestAccess';
import {BenchlingAction} from 'redux-stores/Action';
import {BenchlingState} from 'redux-stores/reduceApp';

import {ManagedModelTypes} from './ManagedModelDefinitions';
import {ManagedModelsActionTypes} from './ManagedModelsReduxActions';

export type InaccessibleModelsState = {
  [modelType in keyof ManagedModelTypes]?: {[key: string]: InaccessibleInfo};
};

export const INACCESSIBLE_MODELS_INITIAL_STATE: InaccessibleModelsState = {};

export class InaccessibleModelSelector {
  constructor(readonly state: BenchlingState) {}

  getInaccessibleInfo<T extends keyof ManagedModelTypes>(
    modelType: T,
    modelKey: string
  ): InaccessibleInfo | null {
    const inaccessibleByType = this.state.models.inaccessibleState[modelType];
    if (!inaccessibleByType) {
      return null;
    }
    return inaccessibleByType[modelKey];
  }
}

export default function reduceInaccessibleModels(
  state: InaccessibleModelsState = INACCESSIBLE_MODELS_INITIAL_STATE,
  action: BenchlingAction
): InaccessibleModelsState {
  switch (action.type) {
    case ManagedModelsActionTypes.MODEL_INACCESSIBLE:
      return {
        ...state,
        [action.modelType]: {
          ...state[action.modelType],
          ...action.inaccessibleInfoByKey,
        },
      };
    default:
      return state;
  }
}
